<!--
 * @Author: your name
 * @Date: 2021-09-17 14:32:13
 * @LastEditTime: 2025-07-19 15:12:57
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\login\ResetPd.vue
-->
<template>
  <div class="reset-pd">
    <div class="title flex-c-c">{{$t('clrp1')}}</div>
    <div class="schedule flex-c-c">
      <span :class="{'active':activeRpwd}">{{$t('clrp2')}}</span> ———>
      <span :class="{'active':!activeRpwd}">{{$t('clrp3')}}</span>
    </div>
    <div class="user-form">
      <el-form :model="user" :rules="rules" ref="userForm" label-width="200px">
        <template v-if="activeRpwd">
          <el-form-item :label="$t('clrp4')" prop="user_name">
            <el-input v-model="user.user_name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('clrp5')" prop="email">
            <el-input type="email" v-model="user.email"></el-input>
          </el-form-item>
          <el-form-item :label="$t('clrp6')" prop="email_code">
            <el-input v-model="user.email_code" auto-complete="new-password">
              <template slot="append">
                <span
                  @click="getVerification"
                  class="email-code-hover"
                  style="user-select: none;"
                  v-if="codeTime <= 0"
                >{{$t('clrp7')}}</span>
                <span
                  class="email-code"
                  style="user-select: none; max-width: 110px; text-align: center;"
                  v-if="codeTime > 0"
                >{{codeTime}}{{ $t('clrp8') }}</span>
              </template>
            </el-input>
          </el-form-item>
        </template>
        <!-- 重置密码设置 -->
        <template v-if="!activeRpwd">
          <el-form-item :label="$t('clrp9')" prop="password">
            <el-input v-model="user.password" type="password" auto-complete="new-password"></el-input>
          </el-form-item>
          <el-form-item :label="$t('clrp10')" prop="rpassword">
            <el-input v-model="user.rpassword" type="password" auto-complete="new-password"></el-input>
          </el-form-item>
        </template>
        <el-form-item label-width="50px">
          <el-button type="primary" @click="submitForm('userForm')" round>{{$t('clrp11')}}</el-button>
        </el-form-item>
        <el-form-item label-width="30px">
          <div @click="setShowType" class="re-login">
            <span>{{$t('clrp12')}}?</span>&nbsp;
            <span style="color: #606266;">{{$t('clrp13')}}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import passwordStrength from '@/assets/scripts/passwordStrength.js'
export default {
  // admin/nindex/forgetPwdGetCode
  //  user_name: this.addForm.name,
  //     email: this.addForm.email


  // email_code: 1234
  // email: 1047143112@qq.com
  // admin/nindex/forgetPwdConfirmCode


  // let formData = {
  //       user_name: this.addForm.name,
  //       email: this.addForm.email,
  //       pwd: encodeURIComponent(JSON.stringify([this.addForm.pass, this.addForm.checkPass])),
  //       email_code: this.addForm.verificationCode
  //     };
  //     let URL = "/admin/nindex/forgetPwdReset";
  name: 'ResetPd',
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('clrp14')));
      } else if (value !== this.user.password) {
        this.user.rpassword = "";
        callback(new Error(this.$t('clrp15')));
      } else {
        callback();
      }
    };
    let passStrength = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (passwordStrength(value).strength < 3) {
        callback(new Error('密码12位及以上且包含字母数字特殊字符'))
      } else {
        callback();
      }
    };
    return {
      codeTime: 0,
      intervalTime: null,
      activeRpwd: true,
      user: {
        user_name: "",
        email_code: "",
        email: "",
        password: "",
        rpassword: "",
      },
      rules: {
        user_name: [{ required: true, message: this.$t('clrp16'), trigger: 'blur' }],
        email: [{ type: 'email', required: true, message: this.$t('clrp17'), trigger: 'blur' }],
        email_code: [{ required: true, message: this.$t('clrp18'), trigger: 'change' }],
        password: [{ validator: passStrength, trigger: 'blur' }],
        rpassword: [{ validator: validatePass, trigger: 'blur' }],
      }
    }
  },
  methods: {
    setShowType() {
      this.$emit("setShowType");
    },
    getVerification() {
      this.codeTime = 120;
      this.$http.post("/admin/nindex/forgetPwdGetCode", { email: this.user.email, user_name: this.user.user_name, timeout: this.codeTime }, () => {
        this.$msg({ message: this.$t('clrp20'), type: "success", showClose: true });
      });
      this.intervalTime = setInterval(() => {
        if (this.codeTime > 0) {
          this.codeTime -= 1
        } else {
          clearInterval(this.intervalTime);
        }
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.user);
          if (this.activeRpwd) {
            this.$http.post("/admin/nindex/forgetPwdConfirmCode", {
              email: this.user.email,
              email_code: this.user.email_code
            }, (res) => {
              if (res.status) {
                this.$msg({ message: res.tips, type: "warning", showClose: true });
              } else {
                this.activeRpwd = false;
              }
            });
          } else {
            let { user_name, email, email_code } = this.user;
            let pwd = encodeURIComponent(JSON.stringify([this.user.password, this.user.rpassword]));
            this.$http.post("/admin/nindex/forgetPwdReset", {
              user_name,
              email,
              email_code,
              pwd
            }, (res) => {
              if (res.status) {
                this.$msg({ message: res.tips, type: "warning", showClose: true });
              } else {
                this.activeRpwd = true;
                this.$emit("setShowType");
              }
            });
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
}
</script>

<style lang="scss" scoped>
.reset-pd {
  background-color: #fff;
  padding-bottom: 20px;
  border-radius: 8px;
  width: 600px;
  overflow: hidden;
  .title {
    height: 50px;
    font-size: 20px;
    color: #fff;
    background-image: linear-gradient(
        270deg,
        #86eae7 0%,
        #4cccf0 45%,
        #11adf8 100%
      ),
      linear-gradient(#ffffff, #ffffff);
    background-blend-mode: normal, normal;
  }
  .schedule {
    height: 60px;
    .active {
      color: #2898ff;
    }
  }
  .user-form {
    padding-right: 30px;
    // padding-top: 10px;
    background-color: #fff;
    .el-form-item + .el-form-item {
      margin-top: 20px;
    }
    /deep/ .el-input-group__append {
      border-radius: 0px 20px 20px 0px;
    }
    .re-login {
      text-align: center;
      line-height: 10px;
      cursor: pointer;
    }
    .email-code {
      cursor: not-allowed;
    }
    .email-code-hover {
      cursor: pointer;
    }
  }
}
</style>